import React from "react";

function Terms(props) {
    return (
        <div
            id="terms"
            className="flex flex-col items-center p-5 md:p-20 flex-grow h-fit"
        >
            <div className="title text-2xl mb-4 text-peachBlack">
                Terms of Use
            </div>
            <div className="text-body text-lg px-20">
                By using this website, you agree to the following terms and
                conditions. If you do not agree, please refrain from using the
                site. <br /> <br /> 1. Use of Our Website - This website is for
                informational purposes only. We aim to provide accurate and
                up-to-date information about our services, hours, and
                promotions. However, we do not guarantee that all information is
                current or error-free. <br />
                <br /> 2. Links to Third-Party Websites - Our website may
                include links to third-party websites, including social media
                platforms like Instagram, Facebook, and others. These links are
                provided for your convenience, and we do not control or endorse
                the content, privacy practices, or policies of these external
                sites. You are encouraged to review the privacy policies and
                terms of use of any third-party site you visit. Peaches is not
                responsible for any issues or disputes arising from your use of
                third-party websites. <br />
                <br /> 3. Intellectual Property - All content on this website,
                including text, images, and branding, is the property of
                Peaches. You may not copy, distribute, or use any materials
                without our express permission. <br />
                <br /> 4. Liability Disclaimer - Your use of this website is at
                your own risk. We are not liable for any damages or losses
                arising from: Inaccuracies or errors on the site. Your
                interactions with third-party websites linked from this site.
                Technical issues or downtime. <br />
                <br /> 5. Modifications to Terms - We reserve the right to
                update these Terms of Use at any time. Changes will be posted on
                this page, and your continued use of the website constitutes
                acceptance of the updated terms. <br />
            </div>
        </div>
    );
}

export default Terms;
